<div class="topic-deleted-modal">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ title | translate }}
    </h4>

    <div class="close-icon" type="button" aria-label="Close" (click)="dismissModal()">
      <i class="ph ph-x"></i>
    </div>
  </div>
  <div class="modal-body">
    <div class="modal-content" [innerHTML]="content | translate: { topicName: topicName }"></div>
  </div>
  <div class="modal-footer">
    <ex-button class="btn-close-modal" (click)="close()" size="x-large">
      {{ 'common.close' | translate }}
    </ex-button>
  </div>
</div>
